import { cookieDomain, Environment } from "../config";
import { getCookie, setCookie } from "./cookie";

const COOKIE_NAME = "userId";
const COOKIE_MAX_AGE_HOURS = 90 * 24; // 90 days

function getCookieDomain(): string {
  if (
    [Environment.LOCAL, Environment.LOCAL_STAGE, Environment.LOCAL_DB].includes(
      import.meta.env.VITE_APP_ENV
    )
  ) {
    return "localhost";
  }
  return cookieDomain;
}

export function setUserIdCookie(userId: string): void {
  setCookie(COOKIE_NAME, userId, COOKIE_MAX_AGE_HOURS, getCookieDomain());
}

export function clearUserIdCookie(): void {
  setCookie(COOKIE_NAME, "", -1, getCookieDomain());
}

export function getUserIdCookie(): string | null {
  return getCookie(COOKIE_NAME);
}
